
export const tipoUso = [
  {cod: 1, nome: 'Conta / Cliente'},
  {cod: 2, nome: 'Conta'},
  {cod: 3, nome: 'Admin'},
  {cod: 4, nome: 'Todos'}
]